import React, { useState } from "react";
import ListComponent from "../components/ListComponent";
import TranslationComponent from "../components/TranslationComponent";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import Constant from "../../../helper/constant.json";

const Translation = ({ setList, sip, makeCall }) => {
  const [apikey, setApikey] = useState(window.config?.accountId);
  const [header, setHeader] = useState();
  const [headerValue, setHeaderValue] = useState();
  const [headerCollection, setHeaderCollection] = useState([
    {
      headerKey: "",
      headerValue: "",
    },
  ]);
  const [, setData] = useState("No Data");
  const handleConfChange = (e) => {
    setApikey(e.target.value);
  };

  function ClearResponse() {
    setData("");
  }
  function makeCallAPI(event) {
    ClearResponse();
    const requestBody = window.config?.call?.requestBody;
    const [api, apiOptions] = makeCallApiInstance(true);
    api
      .makeCall(apikey, requestBody, apiOptions)
      .then((response) => {
        setData(JSON.stringify(response));
        toast.success("Api call success");
      })
      .catch((error) => {
        console.log("error", error);
        toast.error("Failed, StatusCode:" + error?.response?.data?.message);
      });
    setList(false);
  }

  function updateGridHeader(val) {
    setHeaderCollection([...val]);
  }

  function addHeaders() {
    setHeaderCollection([
      ...headerCollection,
      {
        headerKey: "",
        headerValue: "",
      },
    ]);
  }

  const removeElementFromHeaderCol = (index) => {
    if (index > -1) {
      headerCollection.splice(index, 1);
      setHeaderCollection([...headerCollection]);
    }
  };

  const onSave = () => {
    let errorBool = false;
    if (headerCollection && headerCollection.length > 0) {
      headerCollection.map((col) => {
        if (!col.headerKey) {
          toast.error(Constant.HeaderKeyException);
          errorBool = true;
          return;
        }
        if (!col.headerValue) {
          toast.error(Constant.HeaderValueException);
          errorBool = true;
          return;
        }
      });
      if (!errorBool) {
        localStorage.setItem(
          Constant.LocalStorageCustomHeaderItem,
          JSON.stringify(headerCollection)
        );
        setList(false);
      }
    } else {
      localStorage.setItem(
        Constant.LocalStorageCustomHeaderItem,
        JSON.stringify(headerCollection)
      );
      setList(false);
    }
  };

  return (
    <div key="translation">
      <TranslationComponent
        handleClick={makeCallAPI}
        handleChange={handleConfChange}
        sip={sip}
        heading={Constant.CustomHeaders}
        setList={setList}
        makeCall={makeCall}
        setHeader={setHeader}
        header={header}
        setHeaderValue={setHeaderValue}
        headerCollection={headerCollection}
        updateGridHeader={updateGridHeader}
        headerValue={headerValue}
        removeElementFromHeaderCol={removeElementFromHeaderCol}
        addHeaders={addHeaders}
        onSave={onSave}
      />
    </div>
  );
};
Translation.propTypes = {
  setList: PropTypes.any,
  sip: PropTypes.any,
  makeCall: PropTypes.any,
};
export default Translation;
